import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LureoButton from '@/common/LureoButton';
import { NoticeCard } from '@/components/ui/notice-card';
import { serviceMonitor } from './ServiceMonitor';
import { isDisruptionActive } from './connectionUx';

/**
 * Refuses entry to the editor while a Lureo-side disruption is active, instead
 * of booting it and immediately covering it with an overlay. Once entry is
 * granted it never re-blocks; mid-session failures belong to ConnectionOverlay.
 */
export function ServiceGate({ children }: { children: React.ReactNode }) {
  const [blocked, setBlocked] = useState<boolean>(isDisruptionActive);
  const navigate = useNavigate();

  useEffect(() => {
    if (!blocked) return;
    const subscription = serviceMonitor.serviceDisruption$.subscribe(disrupted => {
      if (!disrupted) setBlocked(false);
    });
    return () => subscription.unsubscribe();
  }, [blocked]);

  if (!blocked) return <>{children}</>;

  return (
    <div className="flex h-screen items-center justify-center bg-lureo-neutral px-6">
      <NoticeCard
        title="Lureo is temporarily unavailable"
        actions={
          <LureoButton variant="secondary" suppressTooltip className="h-9 px-5 rounded-lureo-radius-button-pill text-lureo-14 leading-5" onClick={() => navigate('/dashboard')}>
            Back to dashboard
          </LureoButton>
        }
      >
        Your scenes are safe. Please try again in a few minutes. We'll let you in the moment it clears.
      </NoticeCard>
    </div>
  );
}

export default ServiceGate;
